import type { ReactNode } from "react";
import { Link } from "react-router";

/** Хлебные крошки страницы: каркас показывает только раздел, путь — здесь. */
export function Crumbs({ items }: { items: { label: ReactNode; to?: string | undefined }[] }) {
  return (
    <nav className="mb-2 flex flex-wrap items-center gap-1.5 text-[12px] text-fg-faint">
      {items.map((item, n) => (
        <span key={n} className="flex items-center gap-1.5">
          {n > 0 ? <span className="text-border-strong">/</span> : null}
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-text">
              {item.label}
            </Link>
          ) : (
            <span className="text-fg-muted">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
